export const checkBypass = (
  message: string,
  onSuspected: Function,
  onInnocent: Function
) => {
  const REGEX_ACCOUNT_NUMBER = /(\d{1,})(-(\d{1,})){1,}/g;
  const REGEX_CALL_NUMBER = /01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})/g;
  const REGEX_EMAIL = /[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}/;

  if (REGEX_ACCOUNT_NUMBER.test(message)) {
    onSuspected();
    return;
  }

  if (REGEX_CALL_NUMBER.test(message)) {
    onSuspected();
    return;
  }

  if (REGEX_EMAIL.test(message)) {
    onSuspected();
    return;
  }

  return onInnocent();
};
